import React from "react";
import '../styles/Support.css';
import Header from "./Hero Section/Header";
import Side from "./Hero Section/Side";
import DarkModeSide from "./DarkModeSide";
import Footer from '../components/footer/Footer';
import { useTranslation } from "react-i18next";
export default function Support() {
    const {t} = useTranslation();
  return (
    <>
      <Side />
      <Header />
      <DarkModeSide/>
      <div className="Support-Hero">
        <div className="Support-content">
            <h1>Support Technique</h1>  
        </div>
      </div>
      <div className="Support-form">
      <h3>Contact our technical and after-sales teams</h3>
      <p>Find answers to all your questions in less than 24 hours</p>
      <form className="form-content" id="support-form" name="support-form" action="https://formsubmit.co/77a8b6c97510f429fae14ee631564a5f" method="POST">
          <div className="flex">
            <label>
              <span>{t("contactInfo.nom")}</span>
              <input className="input" type="text" name="name" required={true} />
            </label>
            <label>
              <span>Raison Social</span>
              <input className="input" type="text" name="Raison-social" required={true} />
            </label>
          </div>

          <div className="flex">
            <label>
              <span>{t("contactInfo.telephone")}</span>
              <input className="input" type="number" name="phone" required={true} />
            </label>
            <label>
              <span>E-mail</span>
              <input className="input" type="email" name="email" required={true} />
            </label>
          </div>
          <div className="flex-col">
          <label>
            <span>Request Type</span>
            <select className="input" name="Request-type">
                <option value={'1'}>1</option>
            </select>
          </label>
          </div>
          <div className="flex-col">
          <label>
            <span>message</span>
            <textarea
              className="input01"
              placeholder
              rows={3}
              required={true}
              defaultValue={""}
              name="message"
            />
          </label>
            </div>
          <div className="flex">
            <button type="submit">
              <div className="svg-wrapper-1">
                <div className="svg-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      fill="currentColor"
                      d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                    />
                  </svg>
                </div>
              </div>
              <span>Send</span>
            </button>
          </div>
        </form>
      </div>
      <Footer/>
    </>
  );
}
